export function handleScroll() {
    var subNav = document.getElementsByClassName("btn-enquiries")[0] as HTMLElement;
    if (subNav != null) {
        const position = subNav.offsetHeight + 100;
        if (window.scrollY > position) {
            subNav.classList.add('scroll');
        } else {
            subNav.classList.remove('scroll');
        }
    }
}

